<template>
    <div class="d-flex align-items-center section-title text-center w-100" :class="{[extraClass]: extraClass}">
        <hr class="flex-grow-1 me-2 hr-black" />
        <h4 class="text-uppercase fw-bold mb-0">{{ title }}</h4>
        <hr class="flex-grow-1 ms-2 hr-black" />
    </div>
</template>

<script setup>
defineProps({
    title: String,
    extraClass: String
});
</script>
